
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Le Tessin durant la première vague`}</h2>
    <p>{`Le Tessin est particulièrement touché lors de la première vague. Les unités de soins intensifs y ont été parfois davantage surchargées que lors de la deuxième vague (les chiffres détaillés sont disponibles dans notre `}<a parentName="p" {...{
        "href": "https://interactif.24heures.ch/2020/covid19-aujourd-hui/"
      }}>{`tableau de bord interactif`}</a>{`). Et dans le canton du Sud, 300 personnes sont mortes du Covid-19 lors de cette première vague, soit deux fois plus qu'en temps normal.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;